























































































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { checkMobile } from '../../utils/utils'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'
import api from '../../../api/v2/api'
import { Activity, Tracking } from '../../../api/v2/models/activity_data'
import { format } from 'date-fns'
import UserTrackingChangeDialog from '../atoms_molecules/UserTrackingChangeDialog.vue'
import DashboardChart from '../organisms/DashboardChart.vue'
import { subMonths, eachDay } from 'date-fns'
import { Route } from 'vue-router'

@Component({
  components: {
    UserTrackingChangeDialog,
    DashboardChart
  }
})
export default class ActivityList extends Vue {
  mobile: boolean = checkMobile()

  loading = false
  forceReload = true

  // ▼ ページ番号 (0スタート)
  page = 0
  // 最終ページかどうか（サーバーが返す）
  isEnd = false

  trackingUsers: Tracking[] = []
  activities: Activity[] = []

  dateRange = {
    startDate: subMonths(new Date(), 1),
    endDate: new Date()
  }

  async created() {
    headerState.setTitle('アクティビティ')
    footerState.setFooterDefault()
    await this.updateDateRange(this.page)
    this.scrollToLink()
  }

  /**
   * ダッシュボードから日付範囲が変わったときに呼ばれる
   */
  updateRangeDate(newDateRange) {
    this.dateRange = newDateRange
    // ページをリセット
    this.page = 0
    this.updateDateRange(this.page)
  }

  /**
   * Vuetifyのページネーションでページが切り替わったとき
   * newPage は 1スタートなので、実際の page へは (newPage - 1) をセット
   */
  onPageChange(newPage: number) {
    const actualPage = newPage - 1
    // すでに読み込み中でなければ
    if (!this.loading) {
      this.updateDateRange(actualPage)
    }
  }

  /**
   * APIから指定ページのデータを取得
   */
  async updateDateRange(page: number) {
    if (this.loading) return
    this.loading = true

    try {
      const response = await api.activity.get(page, this.dateRange)
      this.trackingUsers = response.trackingUsers
      this.activities = response.activities

      this.page = page
      this.isEnd = response.isEnd
    } catch (error) {
      console.error(error)
    } finally {
      this.loading = false
    }
  }

  /**
   * 学習時間を手動で更新
   */
  async updateTracking(tracking: Tracking, totalRecordedValue: number) {
    await api.tracking.updateTracking(
      tracking.id,
      totalRecordedValue,
      format(tracking.trackingDate, 'YYYY-MM-DD')
    )

    if (tracking.id === -1) {
      // 新規追加
      tracking.totalRecordedValue = totalRecordedValue
      this.trackingUsers.push(tracking)
    } else {
      // 既存レコード更新
      const found = this.trackingUsers.find((item) => item.id === tracking.id)
      if (found) {
        found.totalRecordedValue = totalRecordedValue
      }
    }

    // ダッシュボードの更新
    ;(this.$refs.dashboard as any).updateDateRange()
  }

  /**
   * 日付とアクティビティのまとめ
   */
  get trackingUserSummaries() {
    const summaries = eachDay(
      new Date(this.dateRange.startDate),
      new Date(this.dateRange.endDate)
    ).map((currentDay) => {
      const trackingUser = this.trackingUsers.find(
        (item) => this.dateFormat(item.trackingDate) === this.dateFormat(currentDay)
      )

      if (trackingUser) {
        return {
          trackingUser,
          activities: this.activities.filter(
            (activity) =>
              this.dateFormat(trackingUser.trackingDate) ===
              this.dateFormat(activity.createdAt)
          )
        }
      }
      // 該当する trackingUser が無い場合は空データ
      return {
        trackingUser: Tracking.createEmpty(currentDay),
        activities: []
      }
    })
    return summaries.reverse()
  }

  /**
   * ▼ 以下、表示用ユーティリティ
   */
  // "YYYY年MM月DD日" のようなフォーマット
  dateFormat(date: Date) {
    // 例: 「2025年02月16日」
    return format(date, 'YYYY年MM月DD日')
  }

  // "HH時mm分" のようなフォーマット
  timeFormat(date: Date) {
    return format(date, 'HH時mm分')
  }
  // 学習時間(分)を「時間:分」に変換
  timeValueToHour(trackingUser: Tracking) {
    return Math.floor(Math.round(trackingUser.totalRecordedValue / 60) / 60)
  }
  timeValueToMinutes(trackingUser: Tracking) {
    return (
      Math.round(trackingUser.totalRecordedValue / 60) -
      this.timeValueToHour(trackingUser) * 60
    )
  }

  /**
   * ▼ 簡易的に「全ページ数」を推定する
   * - サーバーが totalPages を返さない代わりに isEnd だけ持っている場合の苦肉の策
   * - isEnd が false なら「まだ次のページがあるかも？」と考えて page+2
   * - isEnd が true なら「これが最終ページ」で page+1
   * - 本来はサーバーから totalItems or totalPages を受け取り、正確に計算するのがおすすめ
   */
  get totalPages() {
    // 0スタートの page に合わせて算出
    if (this.isEnd) {
      // もう次は無い => 今のページが最終 => page+1
      return this.page + 1
    } else {
      // 次のページがあるかも => page+2
      return this.page + 2
    }
  }

  saveNavigationPath(link: Partial<Route>, id: string) {
    sessionStorage.setItem('previousPage', this.$route.path + '?id=activity-link-' + id);
    this.$router.push(link);
  }

  scrollToLink() {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');
    if (id) {
      const element = document.getElementById(id)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    }
  }
}
